module.exports = __webpack_public_path__ + "static/media/390x310-Cape-Town.78a2f96e.jpg";